module.exports = __webpack_public_path__ + "static/media/received.1631bcdd.svg";


//////////////////
// WEBPACK FOOTER
// /src/assets/icons/received.svg
// module id = ./src/assets/icons/received.svg
// module chunks = 0